// TODO - replace with ADS QBE Icon

import type { SvgIconProps } from '@mui/material/SvgIcon';
import SvgIcon from '@mui/material/SvgIcon';
import * as React from 'react';

const MastercardIcon = ({ fontSize }: SvgIconProps) => (
  <SvgIcon fontSize={fontSize}>
    <svg
      viewBox="0 0 48 48"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <g id="Foundation" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Iconography-/-Decorative" transform="translate(-606, -3198)" fillRule="nonzero">
          <g id="Mastercard" transform="translate(606, 3198)">
            <rect id="Rectangle" fill="#FFFFFF" opacity="0" x="0" y="0" width="48" height="48" />
            <g id="mastercard-color_large" transform="translate(0, 8)">
              <rect id="card_bg" fill="#F2F0EC" x="0" y="0" width="48" height="32" rx="4" />
              <g id="mastercard" transform="translate(4.65, 3.2)">
                <g id="Group" opacity="0" fill="#FFFFFF">
                  <rect id="Rectangle" x="0" y="0" width="38.71" height="25.6" />
                </g>
                <rect
                  id="Rectangle"
                  fill="#F26122"
                  x="14.25"
                  y="4.46"
                  width="10.21"
                  height="16.68"
                />
                <path
                  d="M15.35,12.8 C15.3331352,9.5535343 16.8077071,6.4790519 19.35,4.46 C15.0002514,1.03929485 8.751948,1.53602007 4.99729399,5.6010059 C1.24263998,9.66599173 1.24263998,15.9340083 4.99729399,19.9989941 C8.751948,24.0639799 15.0002514,24.5607051 19.35,21.14 C16.8077071,19.1209481 15.3331352,16.0464657 15.35,12.8 Z"
                  id="Path"
                  fill="#EA1D25"
                />
                <path
                  d="M35.49,19.37 L35.49,19.03 L35.64,19.03 L35.64,18.96 L35.29,18.96 L35.29,19.03 L35.43,19.03 L35.43,19.37 L35.49,19.37 Z M36.17,19.37 L36.17,18.96 L36.07,18.96 L35.95,19.25 L35.82,18.96 L35.72,18.96 L35.72,19.37 L35.79,19.37 L35.79,19.06 L35.91,19.33 L35.99,19.33 L36.1,19.06 L36.1,19.37 L36.17,19.37 Z"
                  id="Shape"
                  fill="#F69E1E"
                />
                <path
                  d="M36.51,12.8 C36.5073869,16.8593443 34.188851,20.5613981 30.5378671,22.3358273 C26.8868832,24.1102566 22.543465,23.6460056 19.35,21.14 C23.950057,17.5179566 24.7466531,10.8542961 21.13,6.25 C20.6115505,5.58327007 20.013815,4.98217649 19.35,4.46 C22.543465,1.95399441 26.8868832,1.48974344 30.5378671,3.26417268 C34.188851,5.03860192 36.5073869,8.74065575 36.51,12.8 L36.51,12.8 Z"
                  id="Path"
                  fill="#F69E1E"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  </SvgIcon>
);

export default MastercardIcon;
